import { IInvoicesParams, IReviewsParams } from "../types";
import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IInvoiceForTable } from "../../models/Invoice";
import { InvoiceService } from "../../services/invoice.service";
import { IReview } from "../../models/Review";
import { ReviewService } from "../../services/review.service";

export const useGetAllReviewsWithPaginationQuery = (data: IReviewsParams) => {
  return useQuery<{ data: IReview[]; totalCount: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_REVIEWS_WITH_PAGINATION, data],
    // refetchOnMount: false,
    staleTime: 5000,
    // refetchInterval: 5000,
    queryFn: () =>
      ReviewService.getReviews(data.currentPage, data.pageSize, data.queryOptions).then(
        (res) => res.data
      ),
  });
};
